import axios from 'axios';
import { HKTDC_PARTICIPANTS_API_URL } from 'appenv';

const defaultFilterOptions = {
  majorProductHandled: [],
  nob: [],
  businessRegion: [],
  country: [],
};

function fetchHKTDCParticipantsData(keyWord = '', limit = 20, lastCursor = '', filterOptions = defaultFilterOptions, domain = '') {
  const {
    majorProductHandled,
    nob,
    businessRegion,
    country,
  } = filterOptions;

  return axios({
    method: 'post',
    url: HKTDC_PARTICIPANTS_API_URL,
    data: {
      cursor: lastCursor,
      limit,
      searchKeyword: keyWord,
      majorProductHandled,
      nob,
      businessRegion,
      domain,
      country,
    },
  }).then((result) => result.data);
}

export default fetchHKTDCParticipantsData;
